<!-- <p>descriptor-categoria-item works!</p> -->
<div *ngIf="descriptorCategoriaObs$ | async as ch">
  <h5>Valor: {{ ch[0].value }}</h5>
  <h5>Descripcion: {{ ch[0].description }}</h5>
</div>
